import React from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Coins, CalendarCheck } from "lucide-react";

const DailyRewardPop = ({ open, amount, onClose }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent
      data-testid="daily-reward-pop"
      className="theme-light bg-[#1E293B] border border-[#10B981]/40 text-white max-w-xs p-6 text-center overflow-hidden"
    >
      <div className="relative mx-auto mb-4 w-20 h-20 flex items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-[#10B981]/15 animate-ping" />
        <span className="relative w-20 h-20 rounded-full bg-[#10B981]/15 border border-[#10B981]/40 flex items-center justify-center">
          <Coins className="w-9 h-9 text-[#10B981]" />
        </span>
      </div>
      <div className="inline-flex items-center gap-1.5 text-[11px] font-semibold label-eyebrow text-[#10B981]">
        <CalendarCheck className="w-4 h-4" /> Daily top-up
      </div>
      <div className="font-display font-extrabold text-5xl text-[#10B981] mt-2" data-testid="daily-reward-amount">
        +£{amount}
      </div>
      <p className="text-slate-300 text-sm mt-1">Virtual £ added to your balance.</p>
      <p className="text-muted-38 text-xs mt-1">Come back tomorrow for £{amount} more.</p>
      <button
        data-testid="daily-reward-collect"
        onClick={onClose}
        className="btn-green w-full rounded-xl py-3 font-semibold mt-5"
      >
        Collect
      </button>
    </DialogContent>
  </Dialog>
);

export default DailyRewardPop;
